/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.190.0-v202609092116-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqProjectsApiClass {
 
   constructor() {}

  /**
   * @summary Report the results of a scheduled notebook execution. For internal use only.
   * @param {string} id - ID of the Scheduled Notebook
  */
  public addScheduleNotebookResult(
    body: models.ScheduledNotebookResultInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/projects/scheduledNotebooks/${encodeURIComponent(String(id))}/result`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ScheduledNotebookOutputV1>;
  }

  /**
   * @summary Archive or delete a project
   * @param {string} id - ID of the project to archive or delete
   * @param {boolean} [_delete=false] - Permanently and irretrievably delete the project and its data
  */
  public archiveProject(
    {
      id,
      _delete
    } : {
      id: string,
      _delete?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/projects/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['delete']: _delete
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a project
  */
  public createProject(
    body: models.ProjectInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/projects`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ProjectOutputV1>;
  }

  /**
   * @summary Get a project
   * @param {string} id - ID of the project to retrieve
  */
  public getProject(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/projects/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ProjectOutputV1>;
  }

  /**
   * @summary List projects
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {boolean} [includeArchived] - If set to true, archived projects will be included in the results. Default is false.
  */
  public getProjects(
    {
      offset,
      limit,
      includeArchived
    } : {
      offset?: number,
      limit?: number,
      includeArchived?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/projects`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit,      ['includeArchived']: includeArchived
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetProjectsOutputV1>;
  }

  /**
   * @summary Get the details of a scheduled notebook
   * @param {string} id
  */
  public getScheduledNotebook(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/projects/scheduledNotebooks/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ScheduledNotebookOutputV1>;
  }

  /**
   * @summary List all scheduled notebooks the current user has scheduled
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {boolean} [isEnabled=false] - Set to true to filter only the notebooks which are enabled
  */
  public getScheduledNotebooks(
    {
      offset,
      limit,
      isEnabled
    } : {
      offset?: number,
      limit?: number,
      isEnabled?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/projects/scheduledNotebooks`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit,      ['isEnabled']: isEnabled
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ScheduledNotebookListOutputV1>;
  }

  /**
   * @summary Update a project
   * @param {string} id - The Seeq ID for the project
  */
  public putProject(
    body: models.ProjectInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/projects/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ProjectOutputV1>;
  }

  /**
   * @summary Schedule a Notebook within a Project to run on a set interval
   * @param {string} id - ID of the Project containing the Notebook to schedule
  */
  public scheduleNotebook(
    body: models.ScheduledNotebookInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/projects/${encodeURIComponent(String(id))}/scheduleNotebook`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ScheduledNotebookOutputV1>;
  }

  /**
   * @summary Archive Scheduled Notebook(s) within a Project so that it will no longer run
   * @param {string} id - ID of the Project containing the Notebook to unschedule
   * @param {string} filePath - The path to the Notebook file. Using &#x27;*&#x27; will unschedule all Notebooks for this Project, regardless of their label
   * @param {string} [label] - The label for the Notebook schedule. Using &#x27;*&#x27; will unschedule all labels for this filePath
  */
  public unscheduleNotebook(
    {
      id,
      filePath,
      label
    } : {
      id: string,
      filePath: string,
      label?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (filePath === null || filePath === undefined) {
      throw new Error("'filePath' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/projects/${encodeURIComponent(String(id))}/scheduleNotebook`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['filePath']: filePath,      ['label']: label
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ScheduledNotebookListOutputV1>;
  }

}


export const sqProjectsApi = new sqProjectsApiClass();

export type sqProjectsApiEndpoints = {
  'addScheduleNotebookResult': {
    method: 'post';
    path: '/projects/scheduledNotebooks/${encodeURIComponent(String(id))}/result';
    response: models.ScheduledNotebookOutputV1;
  };
  'archiveProject': {
    method: 'delete';
    path: '/projects/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'createProject': {
    method: 'post';
    path: '/projects';
    response: models.ProjectOutputV1;
  };
  'getProject': {
    method: 'get';
    path: '/projects/${encodeURIComponent(String(id))}';
    response: models.ProjectOutputV1;
  };
  'getProjects': {
    method: 'get';
    path: '/projects';
    response: models.GetProjectsOutputV1;
  };
  'getScheduledNotebook': {
    method: 'get';
    path: '/projects/scheduledNotebooks/${encodeURIComponent(String(id))}';
    response: models.ScheduledNotebookOutputV1;
  };
  'getScheduledNotebooks': {
    method: 'get';
    path: '/projects/scheduledNotebooks';
    response: models.ScheduledNotebookListOutputV1;
  };
  'putProject': {
    method: 'post';
    path: '/projects/${encodeURIComponent(String(id))}';
    response: models.ProjectOutputV1;
  };
  'scheduleNotebook': {
    method: 'post';
    path: '/projects/${encodeURIComponent(String(id))}/scheduleNotebook';
    response: models.ScheduledNotebookOutputV1;
  };
  'unscheduleNotebook': {
    method: 'delete';
    path: '/projects/${encodeURIComponent(String(id))}/scheduleNotebook';
    response: models.ScheduledNotebookListOutputV1;
  };
};

type ApiAddScheduleNotebookResultResponse = models.ScheduledNotebookOutputV1;
type ApiaddScheduleNotebookResultMutationParams = Parameters<typeof sqProjectsApi.addScheduleNotebookResult> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqProjectsApi.addScheduleNotebookResult>;

export function useApiAddScheduleNotebookResultMutation(
  options?: Omit<UseMutationOptions<ApiAddScheduleNotebookResultResponse, AxiosError<SeeqErrorData>,
    ApiaddScheduleNotebookResultMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiAddScheduleNotebookResultResponse, AxiosError<SeeqErrorData>,
  ApiaddScheduleNotebookResultMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiaddScheduleNotebookResultMutationParams) =>
      sqProjectsApi.addScheduleNotebookResult(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveProjectResponse = models.ArchiveOutputV1;
type ApiarchiveProjectMutationParams = Parameters<typeof sqProjectsApi.archiveProject> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqProjectsApi.archiveProject>;

export function useApiArchiveProjectMutation(
  options?: Omit<UseMutationOptions<ApiArchiveProjectResponse, AxiosError<SeeqErrorData>,
    ApiarchiveProjectMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveProjectResponse, AxiosError<SeeqErrorData>,
  ApiarchiveProjectMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveProjectMutationParams) =>
      sqProjectsApi.archiveProject(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateProjectResponse = models.ProjectOutputV1;
type ApicreateProjectMutationParams = Parameters<typeof sqProjectsApi.createProject> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqProjectsApi.createProject>;
type ApicreateProjectMutationVariables = models.ProjectInputV1;

export function useApiCreateProjectMutation(
  options?: Omit<UseMutationOptions<ApiCreateProjectResponse, AxiosError<SeeqErrorData>,
    ApicreateProjectMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateProjectResponse, AxiosError<SeeqErrorData>,
  ApicreateProjectMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateProjectMutationVariables) =>
      sqProjectsApi.createProject(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetProjectResponse = models.ProjectOutputV1;
export function GetProjectQueryKey(
  params: Parameters<typeof sqProjectsApi.getProject>[0],
) {
  return ['sqProjectsApi', 'getProject', params] as const;
}

export function useApiGetProjectQuery(
  params: Parameters<typeof sqProjectsApi.getProject>[0],
  options?: Omit<UseQueryOptions<ApiGetProjectResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetProjectResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetProjectQueryKey(params),
    queryFn: () =>
      sqProjectsApi.getProject(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetProjectsResponse = models.GetProjectsOutputV1;
export function GetProjectsQueryKey(
  params: Parameters<typeof sqProjectsApi.getProjects>[0],
) {
  return ['sqProjectsApi', 'getProjects', params] as const;
}

export function useApiGetProjectsQuery(
  params: Parameters<typeof sqProjectsApi.getProjects>[0],
  options?: Omit<UseQueryOptions<ApiGetProjectsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetProjectsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetProjectsQueryKey(params),
    queryFn: () =>
      sqProjectsApi.getProjects(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetScheduledNotebookResponse = models.ScheduledNotebookOutputV1;
export function GetScheduledNotebookQueryKey(
  params: Parameters<typeof sqProjectsApi.getScheduledNotebook>[0],
) {
  return ['sqProjectsApi', 'getScheduledNotebook', params] as const;
}

export function useApiGetScheduledNotebookQuery(
  params: Parameters<typeof sqProjectsApi.getScheduledNotebook>[0],
  options?: Omit<UseQueryOptions<ApiGetScheduledNotebookResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetScheduledNotebookResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetScheduledNotebookQueryKey(params),
    queryFn: () =>
      sqProjectsApi.getScheduledNotebook(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetScheduledNotebooksResponse = models.ScheduledNotebookListOutputV1;
export function GetScheduledNotebooksQueryKey(
  params: Parameters<typeof sqProjectsApi.getScheduledNotebooks>[0],
) {
  return ['sqProjectsApi', 'getScheduledNotebooks', params] as const;
}

export function useApiGetScheduledNotebooksQuery(
  params: Parameters<typeof sqProjectsApi.getScheduledNotebooks>[0],
  options?: Omit<UseQueryOptions<ApiGetScheduledNotebooksResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetScheduledNotebooksResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetScheduledNotebooksQueryKey(params),
    queryFn: () =>
      sqProjectsApi.getScheduledNotebooks(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiPutProjectResponse = models.ProjectOutputV1;
type ApiputProjectMutationParams = Parameters<typeof sqProjectsApi.putProject> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqProjectsApi.putProject>;

export function useApiPutProjectMutation(
  options?: Omit<UseMutationOptions<ApiPutProjectResponse, AxiosError<SeeqErrorData>,
    ApiputProjectMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPutProjectResponse, AxiosError<SeeqErrorData>,
  ApiputProjectMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiputProjectMutationParams) =>
      sqProjectsApi.putProject(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiScheduleNotebookResponse = models.ScheduledNotebookOutputV1;
type ApischeduleNotebookMutationParams = Parameters<typeof sqProjectsApi.scheduleNotebook> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqProjectsApi.scheduleNotebook>;

export function useApiScheduleNotebookMutation(
  options?: Omit<UseMutationOptions<ApiScheduleNotebookResponse, AxiosError<SeeqErrorData>,
    ApischeduleNotebookMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiScheduleNotebookResponse, AxiosError<SeeqErrorData>,
  ApischeduleNotebookMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApischeduleNotebookMutationParams) =>
      sqProjectsApi.scheduleNotebook(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUnscheduleNotebookResponse = models.ScheduledNotebookListOutputV1;
type ApiunscheduleNotebookMutationParams = Parameters<typeof sqProjectsApi.unscheduleNotebook> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqProjectsApi.unscheduleNotebook>;

export function useApiUnscheduleNotebookMutation(
  options?: Omit<UseMutationOptions<ApiUnscheduleNotebookResponse, AxiosError<SeeqErrorData>,
    ApiunscheduleNotebookMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUnscheduleNotebookResponse, AxiosError<SeeqErrorData>,
  ApiunscheduleNotebookMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiunscheduleNotebookMutationParams) =>
      sqProjectsApi.unscheduleNotebook(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
